import { render, staticRenderFns } from "./EmailStudent.vue?vue&type=template&id=5a021372&scoped=true"
import script from "./EmailStudent.vue?vue&type=script&lang=js"
export * from "./EmailStudent.vue?vue&type=script&lang=js"
import style0 from "./EmailStudent.vue?vue&type=style&index=0&id=5a021372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a021372",
  null
  
)

export default component.exports